import { render, staticRenderFns } from "./NfeFranchise.vue?vue&type=template&id=5575ed94&"
import script from "./NfeFranchise.vue?vue&type=script&lang=js&"
export * from "./NfeFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports